import Http from "@api/http";

export const getMstConfig = async () => {
  try {
    const result = await Http.get("mst/config");
    return result;
  } catch (err) {
    return err;
  }
};

export const getPrefs = async (params) => {
  try {
    const { data } = await Http.get("mst/prefs", params);
    return data;
  } catch (err) {
    return err;
  }
};

export const getCityOptions = async (prefId) => {
  try {
    const { data } = await Http.get(`/mst/prefs/${prefId}/city`);
    return data;
  } catch (err) {
    return err;
  }
};

export const getSMJMstContent = async (screenId) => {
  try {
    const result = await Http.get(`mst/smj-mst-content/${screenId}`);
    return result;
  } catch (err) {
    return err;
  }
};
